import Box from 'ext-ui/components/Box/Box'
import Button from 'ext-ui/components/Button/Button'
import ArrowIcon from 'ext-ui/svg/icon/ArrowIcon'
import CreditCardGradientIcon from 'ext-ui/svg/icon/CreditCardGradientIcon'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'

import style from './EnableVirtualCardCTA.style'

interface EnableVirtualCardCTAProps {
  onEnableClick?: () => void
}

const EnableVirtualCardCTA: React.FC<EnableVirtualCardCTAProps> = ({
  onEnableClick,
}) => {
  const translate = useTranslate()

  return (
    <Box css={style} className="EnableVirtualCardCTA">
      <div className="flex-row align-start gap-4">
        <CreditCardGradientIcon />
        <div className="flex-column gap-5 flex-1">
          <div className="flex-column gap-2">
            <p className="font-h3 font-weight-medium text-primary">
              {translate('Enable Virtual Cards')}
            </p>
            <p className="create-text">
              {translate(
                'Create and send virtual cards in seconds to manage company spend.',
              )}
            </p>
          </div>

          <Button
            className="cta-button flex-row justify-center align-center gap-2"
            variant="secondary"
            onClick={onEnableClick}
          >
            {translate('Enable')}
            <ArrowIcon aria-hidden="true" />
          </Button>
        </div>
      </div>
    </Box>
  )
}

export default EnableVirtualCardCTA
